import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8bfd5c14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block container-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title container-title" }, "发票记录", -1))
const _hoisted_3 = { class: "block-head" }
const _hoisted_4 = { class: "block-search" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 开票时间： ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "table" }
const _hoisted_8 = { class: "cell-wrap" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dot dot-green" }, null, -1))
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "dot",
  style: {"background":"#FFC53D"}
}, null, -1))
const _hoisted_15 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.payDateSolt,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payDateSolt) = $event)),
          type: "daterange",
          class: "date-solt",
          "unlink-panels": "",
          "range-separator": "至",
          "start-placeholder": "开始时间",
          "end-placeholder": "结束时间",
          "value-format": "YYYY-MM-DD"
        }, null, 8, ["modelValue"]),
        _createElementVNode("button", {
          class: "mini-btn",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args))),
          style: {"height":"32px","width":"65px"}
        }, " 查询 ")
      ]),
      _createElementVNode("button", {
        class: "btn",
        style: {"width":"88px","height":"32px"},
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ path: '/invoice/apply' })))
      }, " 申请发票 ")
    ]),
    _hoisted_6,
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"},
        "header-cell-class-name": "table-head",
        "row-style": { color: '#5E617D' }
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "index",
            label: "序号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "company_name",
            label: "开票抬头"
          }),
          _createVNode(_component_el_table_column, {
            prop: "tax_number",
            label: "税号"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            formatter: (item) => item.actual_money + '元',
            label: "发票金额"
          }, null, 8, ["formatter"]),
          _createVNode(_component_el_table_column, {
            prop: "remark",
            "column-key": "remark",
            label: "备注"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(scope.row.remark), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "invoice_date",
            "column-key": "date",
            label: "开票时间"
          }),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态"
          }, {
            default: _withCtx((scope) => [
              (scope.row.status == '已完成' || scope.row.status == '已开票')
                ? (_openBlock(), _createElementBlock("p", _hoisted_9, [
                    _hoisted_10,
                    _createTextVNode(_toDisplayString(scope.row.status), 1)
                  ]))
                : (scope.row.status == '待处理')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(scope.row.status), 1)
                    ]))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            fixed: "right",
            label: "操作"
          }, {
            default: _withCtx((scope) => [
              (scope.row.file)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "link",
                    href: scope.row.file.external_url,
                    target: "_blank"
                  }, " 下载PDF ", 8, _hoisted_15))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(_component_el_pagination, {
        class: "pagination",
        currentPage: _ctx.pageNum,
        "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageNum) = $event)),
        "page-size": _ctx.pageSize,
        "onUpdate:page-size": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pageSize) = $event)),
        "page-sizes": [10, 30, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total,
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange
      }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
    ])
  ]))
}